import { action } from 'satcheljs';

/**
 * Action to dismiss the charm suggestions
 */
export let dismissCharmSuggestions = action('dismissCharmSuggestions');

/**
 * Action to show the charm suggestions
 */
export let showCharmSuggestions = action('showCharmSuggestions');
